import { Option } from '../common/OptionInput';
import { Alert } from "reactstrap";

export const LinkUrl = ({ link, onLinkChange, onTypeChange, type, error }) => {
    return (
        <Option
            id="url"
            checked={type}
            onChange={onTypeChange}
            text="Link to a URL:"
            value="url"
            name="link"
        >
            <div style={{ width: "100%" }}>
                <input
                    className={error == true ? "errorLink" : " "}
                    value={type == "url" ? link : ""}
                    onChange={onLinkChange}
                    disabled={type !== "url"}
                    placeholder="https://www.flimp.net"
                    type="text"
                />
                {error == true && type == "url" && (
                    <Alert
                        color="danger"
                        className="alert"
                        fade={true}
                        style={{ textAlign: "center" }}
                    >
                        <p>Please enter a valid URL </p>
                        <p>(e.g http or https://flimp.net)</p>
                    </Alert>
                )}
            </div>
        </Option>
    )
}
